import { styled } from 'external/material'
import { YouTubePlaylistItem } from './types'
import { useMemo, useContext } from 'external/react'
import { TeacherContext } from 'teacher/context'

const StyledDashboardCarrusel = styled('div')(dashboardCarruselStyles as any)

export default function DashboardCarrusel() {
  const { dashboard, updateState, translate, navigate } = useContext(TeacherContext) as any
  const activeVideo = useMemo(() => dashboard.activeVideo as YouTubePlaylistItem | null, [dashboard.activeVideo])
  const videos = useMemo(() => dashboard.videos as YouTubePlaylistItem[], [dashboard.videos])
  const setActiveVideo = useMemo(() => (video:any) => updateState({dashboard: {activeVideo: {$set: video}}}), [])

  return (
    <StyledDashboardCarrusel>
      <div className='carrusel-header'>
        <div className='carrusel-title'>{translate('Videos')}</div>
      </div>
      <div className='carrusel-content'>
        {videos.length > 0 && 
          <a className='see-more' onClick={() => navigate({},'/:languageId/:role/videos', {preserveQuery: true})}>{translate('see_more')}...</a>
        }
        {videos.map(video => {
          const thumbnail = video.snippet.thumbnails.maxres ?? video.snippet.thumbnails.high
          return ( 
            <div
              key={video.id}
              className="carousel-item-v"
              onClick={() => setActiveVideo(video)}
            >
              <img src={thumbnail?.url} alt={video.snippet.title} />
              <p>{video.snippet.title}</p>
            </div>
          )
        })}
      </div>
      {activeVideo && (
        <div className="modal-overlay" onClick={() => setActiveVideo(null)}>
          <div
            className="modal-content"
            onClick={e => e.stopPropagation()}
          >
            <button
              className="close-button"
              onClick={() => setActiveVideo(null)}
            >
              ✕
            </button>

            <iframe
              src={`https://www.youtube.com/embed/${activeVideo.snippet.resourceId.videoId}?autoplay=1`}
              title={activeVideo.snippet.title}
              allow="autoplay; encrypted-media"
              allowFullScreen
            />
            <h3>{activeVideo.snippet.title}</h3>
          </div>
        </div>
      )}
    </StyledDashboardCarrusel>
  )
}

function dashboardCarruselStyles() {
  return {
    display: 'flex',
    flexGrow: 1,
    minHeight: 310,
    flexDirection: 'column',
    overflowY: 'hidden',
    '& .carrusel-header': {
      display: 'flex',
      marginBottom: '10px',
      '& .carrusel-title': {
        flexGrow: 1,
        marginLeft: 2,
        fontSize: '16pt',
        fontWeight: 500,
        color: '#434a5d',
        '&::after': {
          content: "':'"
        }
      },
    },
    '& .carrusel-content': {
      width: '100%',
      gap: '30px',
      backgroundColor: 'white', 
      borderRadius: '20px',
      height: '205px',
      position: 'relative',
      padding: '40px 30px 30px 30px',
      boxSizing: 'border-box',
      display: 'flex',
      overflow: 'hidden',
      flexWrap: 'wrap'
    },
    '& .see-more': {
      position: 'absolute',
      top: '10px',
      right: '24px',
      cursor: 'pointer'
    },
    '& .carousel-item-v': {
      minWidth: '163px',
      flex: 0,
      cursor: 'pointer',
      transition: 'transform 0.2s'
    },
    '& .carousel-item-v:hover': {
      transform: 'scale(1.05)'
    },
    '& .modal-overlay': {
      position: 'fixed',
      inset: 0,
      background: 'rgba(0, 0, 0, 0.75)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 99999999,
    },
    '& .carousel-item-v img': {
      width: '100%',
      borderRadius: '8px',
      aspectRatio: '16/11',
      objectFit: 'cover',
      marginBottom: '4px'
    },
    '& .carousel-item-v p': { 
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      margin: 0
    },
    '& .modal-content': {
      position: 'relative',
      width: '90%',
      maxWidth: '800px',
      background: '#000',
      borderRadius: '10px',
      padding: '12px',
    },
    '& .modal-content iframe': {
      width: '100%',
      height: '450px',
      borderRadius: '6px',
    },
    '& .modal-content h3': {
      color: 'white',
      marginTop: '10px',
      fontSize: '16px',
    },
    '& .close-button': {
      position: 'absolute',
      top: '6px',
      right: '8px',
      background: 'none',
      border: 'none',
      color: 'white',
      fontSize: '22px',
      cursor: 'pointer',
    }
  }
}
